import { takeEvery, fork, put, all, call } from "redux-saga/effects"

//Account Redux states
import { REGISTER_USER } from "./actionTypes"
import { registerUserSuccessful, registerUserFailed } from "./actions"


import {
  postFakeRegister,
  postJwtRegister,
} from "../../../helpers/apibackend_helper"
import { changePreloader } from "../../../store/actions"



// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user } }) {
  try {
    const response = yield call(postFakeRegister, user)
    yield put(registerUserSuccessful(response))

  } catch (error) {
    yield put(registerUserFailed(error))
  } finally {
    yield put(changePreloader(false));
  }
}

export function* watchUserRegister() {
  yield takeEvery(REGISTER_USER, registerUser)
}

function* accountSaga() {
  yield all([fork(watchUserRegister)])
}

export default accountSaga
